import gql from 'graphql-tag'

import { serverTaskFields } from './fragments'

export default gql`
mutation CA_web_convertAutomationTaskServerFromWindows($id: ID!) {
	cashAssist {
		convertAutomationTaskServerFromWindows(id: $id) {
			...autoTasksServerFields
		}
	}
}
${serverTaskFields}`
